<template>
  <div class="mb-4">
    <div v-for="(route, index) in routes" :key="route.sequence_index">
      <booking-flight-route-detail :route="route" />
      <div v-if="transfers.length > index">
        <v-divider />
        <v-row class="justify-space-around flight-divider">
          <v-col cols="8">
            <span class="white px-2 ml-5 accent--text flight-divider-text">
              {{ $t("booking.transfer") }}
              <v-icon small class="accent--text">shuffle</v-icon>
            </span>
          </v-col>
          <v-col cols="2">
            <span class="white pl-2">
              {{ transfers[index].city_name }}
            </span>
            <span class="white pr-2 accent--text">
              {{ transfers[index].airport_code }}
            </span>
            <span class="white px-2 grey--text" v-if="transfers[index].airport_name != null">
              {{ transfers[index].airport_name }}
            </span>
          </v-col>
          <v-spacer />
          <v-col cols="2" class="text-right primary--text"
            ><span class="white px-2">
              {{ transfers[index].time }}
            </span></v-col
          >
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import BookingFlightRouteDetail from "./BookingFlightRouteDetail.vue";
import FlightTransfer from "../../../models/booking/flightTransfer";
import getTextDateDiff from "../../../repository/getTextDateDiff";

export default {
  name: "BookingFlightRouteCollapse",
  components: { BookingFlightRouteDetail },
  data: () => ({}),
  props: {
    routes: {
      required: true,
      type: Array
    }
  },
  computed: {
    transfers() {
      let transfers = [];
      for (let index = 0; index < this.routes.length - 1; index++) {
        let flightTransfer = new FlightTransfer();
        flightTransfer.airport_code = this.routes[index].end_airport_code;
        flightTransfer.city_name = this.routes[index].end_place_name;
        let startTime = this.routes[index].end_date + " " + this.routes[index].end_time;
        let endTime = this.routes[index + 1].start_date + " " + this.routes[index + 1].start_time;
        flightTransfer.time = getTextDateDiff(startTime, endTime);
        transfers.push(flightTransfer);
      }
      return transfers;
    }
  },
  methods: {
    getTextDateDiff: getTextDateDiff
  }
};
</script>

<style scoped>
.flight-divider {
  font-weight: 700;
  position: relative;
  top: -25px;
}

.flight-divider-text {
  text-transform: uppercase;
}
</style>
